var DiscountType;
(function(DiscountType) {
    DiscountType["Absolute"] = 'ABSOLUTE';
    DiscountType["Relative"] = 'RELATIVE';
})(DiscountType || (DiscountType = {}));
var ProductPriceItemType;
(function(ProductPriceItemType) {
    ProductPriceItemType["SinglePurchase"] = 'SINGLE_PURCHASE';
    ProductPriceItemType["Subscription"] = 'SUBSCRIPTION';
})(ProductPriceItemType || (ProductPriceItemType = {}));

export { DiscountType, ProductPriceItemType };
//# sourceMappingURL=types.js.map
